import Axios from 'axios';
import { ApiResultModel, IDocument } from '../models/common.model';
import {
    IGetKycVideoHintsResponse,
    IGetVideoRequest,
    ISaveVideoRequest,
} from '../models/kyc.model';
import { APIBASE_URL, KYC_URL } from '../config/cacheKey';

export const GetKycVideoHints =
    async (data: { referenceKey: string }): Promise<IGetKycVideoHintsResponse> => {
        return await Axios.post<ApiResultModel<IGetKycVideoHintsResponse>>(
            APIBASE_URL + KYC_URL + '/GetKycVideoHints',
            data
        ).then((result) => {
            return result.data.data;
        });
    };
export const GetVideo =
    async (data: { referenceKey: string }): Promise<IGetVideoRequest> => {
        return await Axios.post<ApiResultModel<IGetVideoRequest>>(
            APIBASE_URL + KYC_URL + '/GetVideo',
            data
        ).then((result) => {
            return result.data.data;
        });
    };
